export const deletePermissionDialogTranslations = {
    en: {
        confirmMessage: 'Are you sure you want to delete permission ?',
        yes: "Yes",
        deleteSuccess: "Permission Deleted Successfully",
        deleteError: "Something went wrong. Please try again later."
    },
    mr: {
        confirmMessage: 'तुम्हाला खात्री आहे की तुम्ही परवानगी हटवू इच्छिता?',
        yes: "होय",
        deleteSuccess: "परवानगी यशस्वीरित्या हटवली",
        deleteError: "काहीतरी चूक झाली. कृपया पुन्हा प्रयत्न करा."
    }
};


